module.exports = __webpack_public_path__ + "img/152.fd9c2004.jpg";